/**
 * Shopify Variant Mapping Configuration
 * 
 * Bu dosya Shopify variant ID'lerini yönetir.
 * 
 * KULLANIM:
 * 1. Shopify admin'de her ürün için variant ID'leri alın
 * 2. Bu dosyayı güncelleyin
 * 3. Ya da Shopify Storefront API otomatik fetch'i kullanın (önerilen)
 */

(function(window) {
    'use strict';

    /**
     * HARDCODE VARIANT MAPPING (FALLBACK)
     * 
     * Eğer Shopify Storefront API kullanılamıyorsa bu mapping kullanılır.
     * 
     * Şu formatta doldurun:
     * 'internal-variant-id': {
     *     'SIZE': 'shopify-variant-id',
     *     ...
     * }
     * 
     * Örnek:
     * '2914': {
     *     'S': '43766199599161',
     *     'M': '43766199631929',
     *     'L': '43766199664697',
     *     ...
     * }
     */
    const HARDCODED_VARIANT_MAP = {
        '2914': { // ARTHUS - Orta Boy Deniz Şortu
            // Shopify Admin'den alınacak variant ID'ler
            // Product ID: 8151292772409
            // TODO: Gerçek variant ID'leri buraya ekleyin
        },
        '2913': { // BOND - Özel Kesim Orta Boy Deniz Şortu
            // Shopify Admin'den alınacak variant ID'ler
            // Product ID: 8151292313657
            // TODO: Gerçek variant ID'leri buraya ekleyin
        },
        '2915': { // ARTHUS BOY - Çocuk Deniz Şortu
            // Shopify Admin'den alınacak variant ID'ler
            // Product ID: 8151293001785
            // TODO: Gerçek variant ID'leri buraya ekleyin
        }
    };

    /**
     * Get variant ID from hardcoded mapping
     * @param {string} internalId - Internal variant ID
     * @param {string} size - Size option
     * @returns {string|null} - Shopify variant ID
     */
    function getVariantIdFromMapping(internalId, size) {
        const productVariants = HARDCODED_VARIANT_MAP[internalId];
        if (!productVariants) {
            return null;
        }

        const sizeUpper = size.toUpperCase();
        return productVariants[sizeUpper] || null;
    }

    /**
     * Check if hardcoded mapping exists for a product
     * @param {string} internalId
     * @returns {boolean}
     */
    function hasHardcodedMapping(internalId) {
        const productVariants = HARDCODED_VARIANT_MAP[internalId];
        return productVariants && Object.keys(productVariants).length > 0;
    }

    /**
     * Get all available sizes for a product from hardcoded mapping
     * @param {string} internalId
     * @returns {Array<string>}
     */
    function getAvailableSizes(internalId) {
        const productVariants = HARDCODED_VARIANT_MAP[internalId];
        if (!productVariants) {
            return [];
        }
        return Object.keys(productVariants);
    }

    /**
     * Update hardcoded mapping programmatically
     * @param {string} internalId
     * @param {Object} variants - { 'SIZE': 'variant-id', ... }
     */
    function updateVariantMapping(internalId, variants) {
        HARDCODED_VARIANT_MAP[internalId] = variants;
        console.log(`Variant mapping updated for ${internalId}:`, variants);
    }

    /**
     * Export variant mapping to JSON (for backup)
     * @returns {string}
     */
    function exportMapping() {
        return JSON.stringify(HARDCODED_VARIANT_MAP, null, 2);
    }

    /**
     * Import variant mapping from JSON
     * @param {string} jsonString
     */
    function importMapping(jsonString) {
        try {
            const imported = JSON.parse(jsonString);
            Object.assign(HARDCODED_VARIANT_MAP, imported);
            console.log('Variant mapping imported successfully');
        } catch (error) {
            console.error('Failed to import variant mapping:', error);
        }
    }

    // Export to global scope
    window.VariantMapping = {
        getVariantId: getVariantIdFromMapping,
        hasMapping: hasHardcodedMapping,
        getAvailableSizes: getAvailableSizes,
        updateMapping: updateVariantMapping,
        exportMapping: exportMapping,
        importMapping: importMapping,
        HARDCODED_MAP: HARDCODED_VARIANT_MAP
    };

    console.log('✅ Variant Mapping module loaded');
    console.log('⚠️  UYARI: Hardcoded variant mapping boş. Shopify Storefront API kullanılacak.');
    console.log('💡 Mapping eklemek için: VariantMapping.updateMapping(internalId, variants)');

})(window);
